/**
 * External dependencies.
 */
import { store, getElement, getContext } from '@wordpress/interactivity';

store('bigbite/query-search', {
  actions: {
    /**
     * Handle search functionality.
     *
     * @param {Proxy<Object>} event Interactivity event data.
     */
    *search(event) {
      let name, value;
      const { ref } = getElement();
      const { hasInstantSearch, enhancedPagination } = getContext();
      const url = new URL(window.location.origin + ref?.closest('div')?.dataset?.url);
      const { actions } = yield import('@wordpress/interactivity-router');

      if (!hasInstantSearch && event?.key !== 'Enter' && ref?.tagName === 'INPUT') {
        return;
      }

      if (ref?.tagName === 'INPUT') {
        name = ref?.name;
        value = ref?.value;
      } else {
        name = ref?.previousElementSibling?.name;
        value = ref?.previousElementSibling?.value;
      }

      if (value === '' && name !== 's') {
        url?.searchParams.delete(name);
      } else {
        url?.searchParams.set(name, value);
      }

      yield actions.navigate(url?.toString());

      if (!enhancedPagination) {
        window.location.reload();
      }
    },
  },
});
